import { FC } from 'react';
import { Link } from "react-router-dom";
import Banners from "../../containers/banner";
import './policy.scss';

interface PageProps {
    title: string;
}

const NeospectraSLA: FC<PageProps> = ({ title }) => {
    return (
        <div className="">
            <Banners title={title} />
            <div className='row'>
                <div className="container">
                    <div className="cont-agg-all">
                        <section>
                            <h3>제1장: 목적</h3>
                            <div className="agg-item_text">
                                본 계약은 [㈜네오스펙트라] (이하 "회사")가 [서비스 사용자] (이하 "사용자")에게 제공하는 [심메타 클라우드 서비스] (이하 "서비스")의 서비스 수준 및 제공 조건에 관한 사항을 규정하는 것을 목적으로 합니다.
                            </div>
                        </section>

                        <section>
                            <h3>제2장: 심메타 클라우드 서비스 품질 수준</h3>
                            <h4>1) 서비스 책임</h4>
                            <ul className="agg-item_list1">
                                <li data-no="-">
                                    회사는 본 서비스에 대하여 해당월 기간 동안 최소 99.5%의 월 가용률을 보장하며, 월 가용률을 충족하지 못하는 경우 회사는 사용자에게 본 SLA에 따라 월 이용금액의 보상율을 적용합니다.
                                </li>
                                <li data-no="-">
                                    클라우드 서비스 내의 모든 이용자 데이터에 대한 권한은 사용자에게 있으며, 해당 데이터로 인해 발생하는 모든 법적, 기술적 책임 또한 사용자 본인에게 있습니다.
                                </li>
                                <li data-no="-">
                                    따라서 사용자는 자신의 데이터를 안전하게 관리하고, 타인의 권리를 침해하지 않도록 주의하여 서비스를 이용해야 합니다.
                                </li>
                            </ul>
                            <br />

                            <h4>2) 용어의 정의</h4>
                            <ul className="agg-item_list1">
                                <li data-no="-">
                                    장애 : 가동 중인 사용자의 인스턴스 또는 태스크의 모든 외부 연결 요청이 5분 이상 동안 계속하여 실패함을 말합니다.                            
                                </li>
                                <li data-no="-">
                                    장애 시간 : 해당월 동안 장애에 해당하는 시간의 총합. 단, 본 SLA의 적용이 배제되는 경우에 그 해당 시간은 장애 시간에 포함되지 않습니다.
                                </li>
                                <li data-no="-">
                                월 가용률(%) = 100 ⅹ [1- 장애 시간의 합(분 단위)/해당월의 총 시간(분 단위)]
                                </li>
                                <li data-no="-">
                                월 이용요금 : 장애가 발생한 해당월의 본 서비스에 대하여 고객이 회사에 실제 지급하는 금액을 의미합니다.
                                </li>
                                <li data-no="-">
                                손해배상 대상 : 최근 1개월(유료 사용 기간만 해당)이상 사용하여 1회 이상 청구서가 발행된 사용자를 대상으로 합니다.                                </li>
                            </ul>
                            <br />

                            <h4>3) 가용률 목표 및 보상 범위</h4>
                            <ul className="agg-item_list1">
                                <li data-no="-">
                                    회사와 사용자간의 별도 계약을 통해서 달리 정하지 않는 한, 회사의 귀책사유로 인하여 발생한 서비스의 성능 및 가용성 문제에 대해서 사용자의 유일한 구제조치는 본 SLA의 조건에 따라 보상율이 적용됩니다.
                                </li>
                                <li data-no="-">
                                    보상율은 아래 표에서 정한 바에 따라 산정되어 적용됩니다(10원 단위 미만은 절삭)
                                </li>
                                <br />
                                <div className="table cs-table-line">
                                    <table>
                                        <colgroup>
                                            <col />
                                            <col />
                                        </colgroup>
                                        <thead>
                                            <tr>
                                                <th scope="col">월 가용률</th>
                                                <th scope="col">보상률</th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            <tr>
                                                <td className="tac">99.0% 이상 ~ 99.5% 미만</td>
                                                <td className="tac">월 이용요금의 10%</td>
                                            </tr>
                                            <tr>
                                                <td className="tac">95.0% 이상 ~ 99.0% 미만</td>
                                                <td className="tac">월 이용요금의 25%</td>
                                            </tr>
                                            <tr>
                                                <td className="tac">95.0% 미만</td>
                                                <td className="tac">월 이용요금의 100%</td>
                                            </tr>
                                        </tbody>
                                    </table>
                                </div>
                            </ul>
                            
                            <h4>4) 데이터 반환 및 폐기정책, 백업 데이터의 보관기관은 다음과 같습니다.</h4>
                            <ul className="agg-item_list1">
                                <li data-no="(1)">
                                    백업 방식 및 주기 : 고객 데이터를 주 1회 이상 백업하며, 전체백업(Full Backup) 방식으로 수행합니다. 단, 시스템 변경, 업그레이드 또는 사용자의 요청이 있을경우 수시 백업을 수행할 수 있습니다.
                                </li>
                                <br /> 

                                <div className="table cs-table-line">
                                    <table>
                                        <colgroup>
                                            <col />
                                            <col />
                                        </colgroup>
                                        <thead>
                                            <tr>
                                                <th scope="col">구분</th>
                                                <th scope="col">내용</th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            <tr>
                                                <td className="tac">고객 데이터</td>
                                                <td className="tac">주 1회 이상</td>
                                            </tr>
                                        </tbody>
                                    </table>
                                </div>
                                <br /> 

                                <li data-no="(2)">
                                    백업 데이터 보관 기간                            
                                </li>
                                <br />
                                <div className="table cs-table-line">
                                    <table>
                                        <colgroup>
                                            <col />
                                            <col />
                                        </colgroup>
                                        <thead>
                                            <tr>
                                                <th scope="col">구분</th>
                                                <th scope="col">내용</th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            <tr>
                                                <td className="tac">백업 데이터</td>
                                                <td className="tac">백업 시점부터 7일</td>
                                            </tr>
                                        </tbody>
                                    </table>
                                </div>

                                <br /> 

                                <li data-no="(3)">
                                    데이터 반환: 사용자의 요청이 있거나 법령에 따라 관계기관의 요청이 있는 경우                           
                                </li>
                                <img src="/infoseed_request_procedure.png" alt="개인정보 열람 등 요구 절차" style={{ width: '50%', margin: '20px auto', display: 'block' }} />
                            
                                <li data-no="(4)">
                                    데이터 폐기: 계약 해제 또는 해지 시 데이터 반환 및 폐기정책을 사용자에게 통보하고 1개월 후 사용자 컨텐츠 및 관련 데이터를 삭제합니다.       
                                </li>
                            </ul>
                        </section>

                        <section>
                            <h3>제3장: 면책 조항</h3>
                            <ul className="agg-item_list1">
                                <li data-no="-">
                                    회사는 다음 각 호의 사유로 인해 발생하는 서비스 불이행에 대해서는 책임을 지지 않습니다.
                                </li>
                                <li data-no="①">
                                    불가항력적인 사유: 자연재해, 전쟁, 테러, 국가 비상사태, 전국적인 네트워크 장애 등 예측 불가능하고 통제 불가능한 상황으로 인한 서비스 중단
                                </li>
                                <li data-no="②">
                                    사용자 책임 사유: 사용자가 회사의 권고나 정책을 따르지 않거나, 보안 관리를 소홀히 하여 발생하는 장애
                                </li>
                                <li data-no="③">
                                    계획된 유지보수: 회사가 사전에 공지한 정기점검으로 인한 서비스 중단                                
                                </li>
                                <li data-no="④">
                                    제3자 서비스 문제: 서비스 운영에 필수적인 외부 서비스(전력, 인터넷 등)의 문제로 인한 서비스 중단                                
                                </li>
                                <li data-no="⑤">
                                    외부 불법 침해: 회사가 보안 조치를 취했음에도 불구하고 외부의 불법적인 침해로 인해 발생한 서비스 장애
                                </li>
                                <li data-no="⑥">
                                    계약에 따른 이용 제한: 서비스 이용약관이나 별도 계약에 따라 회사가 사용자의 서비스 이용 권한을 중단 또는 종료시킨 경우
                                </li>
                                <li data-no="⑦">
                                    요금 미납 또는 무료 이용: 사용자가 이용 요금을 연체 중인 서비스거나, 베타 테스트, 시험 사용, 무료 사용 기간 동안 발생한 장애
                                </li>
                            </ul>
                        </section>

                        <section>
                            <h3>제4장: 기타 사항</h3>
                            <ul className="agg-item_list1">
                                <li data-no="-">
                                    사고/장애 대응: 대내외 기관 및 전문가와 협력 체계를 구축하고, 국가정보원 및 이용기관의 관련 활동에 네이버 클라우드 및 이용기관과 협의하여 협조합니다.
                                </li>
                                <li data-no="-">
                                    보안 관련 협력: 보안 취약점 개선, 사이버 공격 예방/대응, 안전성 확인 등을 위한 보안측정, 점검 등에 네이버 클라우드 및 이용기관과 협의하여 협조합니다.
                                </li>
                            </ul>
                        </section>

                    </div>
                </div>
            </div>
        </div>
    )
}

export default NeospectraSLA;